// Copyright 2025, University of Maryland, All Rights Reserved
import { AxiosInstance } from 'axios'
import type { MonthlyMetricsResponse, YearlyMetricsResponse } from '../types'

export type MetricLevel = 'app' | 'org' | 'workspace'

export const createMetricsApi = (api_instance: AxiosInstance) => ({
  getMonthlyMetrics: async (
    year: number,
    organization_id: string,
    workspace_id: string,
    level: MetricLevel = 'workspace'
  ): Promise<MonthlyMetricsResponse> => {
    let endpoint = ''

    switch (level) {
      case 'app':
        endpoint = `/metrics/rollups/${year}/monthly`
        break
      case 'org':
        endpoint = `/org/${organization_id}/metrics/rollups/${year}/monthly`
        break
      case 'workspace':
        endpoint = `/org/${organization_id}/ws/${workspace_id}/metrics/rollups/${year}/monthly`
        break
    }

    const response = await api_instance.get<MonthlyMetricsResponse>(endpoint)
    return response.data
  },

  getYearlyMetrics: async (
    year: number,
    organization_id: string,
    workspace_id: string,
    level: MetricLevel = 'workspace'
  ): Promise<YearlyMetricsResponse> => {
    let endpoint = ''

    switch (level) {
      case 'app':
        endpoint = `/metrics/rollups/${year}`
        break
      case 'org':
        endpoint = `/org/${organization_id}/metrics/rollups/${year}`
        break
      case 'workspace':
        endpoint = `/org/${organization_id}/ws/${workspace_id}/metrics/rollups/${year}`
        break
    }

    const response = await api_instance.get<YearlyMetricsResponse>(endpoint)
    return response.data
  },
})
